import React, { useState, useEffect, useRef } from 'react';
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';

const TABS = [
  { id: 'rooms', label: 'Rooms' },
  { id: 'about', label: 'About' },
  { id: 'photos', label: 'Photos' },
];

const HotelTabsContainer = () => {
  const [activeTab, setActiveTab] = useState('rooms');
  const contentRef = useRef(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    const sections = el.querySelectorAll('.hotel-tabs-section');
    sections.forEach((section, i) => {
      const tab = TABS[i]?.id;
      section.setAttribute('data-active', tab === activeTab ? 'true' : 'false');
    });
  }, [activeTab]);

  return (
    <NodeViewWrapper as="div" className="hotel-tabs-container">
      <div className="hotel-tabs-bar" role="tablist">
        {TABS.map(({ id, label }) => (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={activeTab === id}
            className={`hotel-tabs-tab ${activeTab === id ? 'hotel-tabs-tab--active' : ''}`}
            onClick={() => setActiveTab(id)}
          >
            {label}
          </button>
        ))}
      </div>
      <div ref={contentRef} className="hotel-tabs-content">
        <NodeViewContent />
      </div>
    </NodeViewWrapper>
  );
};

export default HotelTabsContainer;
